import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MonitoringModule } from '@epicuro-next/platform/monitoring';
import { AccountsStateModule } from '@epicuro-next/state/accounts-state';
import { UserStateModule } from '@epicuro-next/state/user-state';

import { EventTrackerDirective } from './directives/event-tracker.directive';

@NgModule({
  declarations: [EventTrackerDirective],
  imports: [
    CommonModule,
    MonitoringModule,
    UserStateModule,
    AccountsStateModule,
  ],
  exports: [EventTrackerDirective],
})
export class EventTrackerModule {}
